(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-upsell"] && !Shopify.designMode) return;
  try {
    /* Bundle upsell carousel: swipe or scroll the track; the arrows step one slide and the
     counter follows the visible slide. */
  (() => {
    const position = (track) => Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));

    const sync = (track) => {
      const root = track.closest('.hfs-bundle-upsell');
      const total = track.children.length;
      const index = Math.min(position(track), total - 1);
      const label = root?.querySelector('[data-upsell-position]');
      if (label) label.textContent = `${index + 1} / ${total}`;
      root?.querySelectorAll('[data-upsell-step]').forEach((button) => {
        const step = Number(button.dataset.upsellStep);
        button.disabled = step < 0 ? index === 0 : index >= total - 1;
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-upsell-step]') : null;
      const track = button?.closest('.hfs-bundle-upsell')?.querySelector('.hfs-bundle-upsell__track');
      if (!track) return;
      const next = position(track) + Number(button.dataset.upsellStep);
      track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
    });

    document.addEventListener(
      'scroll',
      (event) => {
        if (event.target instanceof Element && event.target.matches('.hfs-bundle-upsell__track')) sync(event.target);
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["size-list"] && !Shopify.designMode) return;
  try {
    /* Hovering or focusing a size row shows its sizing diagram in the section's measure guide;
     leaving it restores the page's own diagram. */
  (() => {
    const ROW = '.hfs-size-row[data-sizing-src]';

    const show = (row, on) => {
      const img = row.closest('.shopify-section')?.querySelector('.hfs-measure-guide__image');
      if (!img) return;
      if (img.dataset.defaultSrc === undefined) {
        img.dataset.defaultSrc = img.getAttribute('src') || '';
        img.dataset.defaultSrcset = img.getAttribute('srcset') || '';
      }
      if (on) {
        img.removeAttribute('srcset');
        img.src = row.dataset.sizingSrc;
      } else {
        img.src = img.dataset.defaultSrc;
        if (img.dataset.defaultSrcset) img.srcset = img.dataset.defaultSrcset;
      }
    };

    const onEnter = (event) => {
      const row = event.target instanceof Element ? event.target.closest(ROW) : null;
      if (row && !row.contains(event.relatedTarget)) show(row, true);
    };
    const onLeave = (event) => {
      const row = event.target instanceof Element ? event.target.closest(ROW) : null;
      if (row && !row.contains(event.relatedTarget)) show(row, false);
    };

    document.addEventListener('pointerover', onEnter);
    document.addEventListener('pointerout', onLeave);
    document.addEventListener('focusin', onEnter);
    document.addEventListener('focusout', onLeave);
  })();
  } catch(e) { console.error(e); }
})();

})();
